import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { ASSISTED_USER_ID, ASSISTED_USER_NAME, ASSISTED_USER_NUMBER, ORDERING_FOR_SELECTED_FARMER } from '@/constants/common';
import { VrNetworkList } from '@/utils/api/fetchVrNetwork';
import { getCookieValue, isSessionStorageAvailable } from '@/utils/helper';
import { randomGradient } from '@/utils/randomGradient';
const ChangeFarmer = () => {
  const router = useRouter();
  const {
    campaignId
  } = router.query;
  const {
    t
  } = useTranslation('address');
  const storeFarmer = typeof window !== 'undefined' && isSessionStorageAvailable(window) ? sessionStorage.getItem(ORDERING_FOR_SELECTED_FARMER) : null;
  const selectedFarmer: VrNetworkList | null = storeFarmer ? JSON.parse(storeFarmer) : null;
  const assistedUserId = getCookieValue(ASSISTED_USER_ID);
  const assistedUserName = getCookieValue(ASSISTED_USER_NAME);
  const assistedUserNumber = getCookieValue(ASSISTED_USER_NUMBER);
  const isAssumeUser = !!assistedUserId && !!assistedUserName && !!assistedUserNumber;
  return <>
      <div className="p-4 pt-6">
        <p className="mb-4 font-medium text-neutral-90 text-sm">Ordering for</p>
        <div className={`farmer-card flex justify-between items-center pl-3 px-4 py-4 border bg-gray-10 border-gray-20 rounded-xl`}>
          <div className="flex items-center gap-4">
            <p className="flex justify-center items-center rounded-full w-12 h-12 font-medium text-white text-xl" style={{
            backgroundImage: randomGradient()
          }}>
              {((selectedFarmer?.full_name || assistedUserName) as string)?.charAt(0).toUpperCase()}
            </p>
            <div className="gap-0.5">
              <p className="font-semibold text-neutral-90 text-base text-start">
                {selectedFarmer?.full_name || assistedUserName || '--'}
              </p>

              <p className="font-normal text-neutral-70 text-xs text-start">
                {selectedFarmer?.phone_number || assistedUserNumber || '--'}
              </p>
            </div>
          </div>
          {!isAssumeUser && <button onClick={() => router.replace({
          pathname: '/select-farmer',
          query: window.location.pathname.includes('farmer-services/cart') ? {
            fs: true
          } : window.location.pathname.includes('campaign/') ? {
            redirect_uri: `/campaign/${campaignId}/cart`
          } : {}
        })}>
              <p className="font-semibold text-primary-100 text-base text-right">
                {t('change')}
              </p>
            </button>}
        </div>
      </div>
      <hr />
    </>;
};
export default ChangeFarmer;